import {FullGameFetchHandler} from "../../../../../core/handlers/full-game.fetch-handler";
import {LiveStreamingModuleState} from "../models/live-streaming-module.state";
import {LIVE_STREAMING_MODULE} from "../live-streaming-widget.consts";

export class LiveStreamingModuleFetchHandler extends FullGameFetchHandler {
  state: LiveStreamingModuleState;

  onLoaded() {
    super.onLoaded();

    this.state.stripColorMode = this.state.appState.appLiveStreamingDisplayModel.stripColorMode
  }

  async action() {
    await super.action()

    await this.controller.action(LIVE_STREAMING_MODULE.ACTION_TYPES.onDisplayEvent, {
      gameId: this.state.gameId,
      status: this.state.statusGroup,
      bookieId: this.state.bookmakerId,
      urlLink: this.state.bookmakerLink,
      stripType: this.state.stripColorMode
    })
  }
}
